import { Calculator, Diamond, Pencil } from 'lucide-solid'
import { Show, onCleanup, onMount } from 'solid-js'
import { useService } from 'solid-services'
import { Grid } from 'styled-system/jsx'
import { Tabs } from '../../../components/ui/tabs'
import Confirm from './Confirm'
import Details from './Details'
import Success from './Success'
import { FormSteps, useCreate } from './state'

export default function Create() {
	const { step, setStep, createSuccess } = useService(useCreate)()

	onMount(() => {
		setStep(FormSteps.details)
	})

	return (
		<Grid>
			<Tabs.Root
				colorPalette="tscGreen"
				lazyMount
				value={step()}
				onValueChange={(e) => setStep(e.value as FormSteps)}
			>
				<Show when={!createSuccess()}>
					<Tabs.List justifyContent="space-between">
						<Tabs.Trigger
							textTransform="capitalize"
							value={FormSteps.details}
						>
							<Pencil />
							{FormSteps.details}
						</Tabs.Trigger>
						<Tabs.Trigger
							textTransform="capitalize"
							value={FormSteps.confirm}
						>
							<Calculator />
							{FormSteps.confirm}
						</Tabs.Trigger>
						<Tabs.Trigger
							disabled={!createSuccess()}
							textTransform="capitalize"
							value={FormSteps.success}
						>
							<Diamond />
							{FormSteps.success}
						</Tabs.Trigger>
					</Tabs.List>
				</Show>
				<Tabs.Content value={FormSteps.details}>
					<Details />
				</Tabs.Content>
				<Tabs.Content value={FormSteps.confirm}>
					<Confirm />
				</Tabs.Content>
				<Tabs.Content value={FormSteps.success}>
					<Success />
				</Tabs.Content>
			</Tabs.Root>
		</Grid>
	)
}
